import Button from '@rezdy/components/Button';
import Form from '@rezdy/components/Form';
import Field from '@rezdy/components/Form/Field';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import Grid from '@rezdy/components/Grid';
import { Article, Aside, Body } from '@rezdy/components/Layout/Article/Styled';
import Layout from '@rezdy/components/Layout/DarkCentered';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import pendo from '../../services/pendo';
import { getRecaptcha } from '../../services/recaptcha';
import { BookingSoftwareMarketingCard } from '../BookingSoftwareMarketingCard';
import CreatePassword from '../CreatePassword';
import { ErrorMessage } from '../ErrorMessage';
import SecondaryAction from '../Layout/SecondaryAction';
import { Title } from './Styled';

interface IProps extends WithTranslation {
    action: (formData: any) => void;
    context: string;
}

interface IState {
    isLoading: boolean;
    isDirty: boolean;
    message: string;
}

/**
 * @deprecated
 */
class SignUpWithEmail extends React.PureComponent<IProps, IState> {
    state = {
        isLoading: false,
        isDirty: false,
        message: '',
    };

    componentDidMount() {
        getRecaptcha().render();
        pendo.trackEvent(pendo.buildAnonymousVisitor(), 'Old Sign Up - Form Viewed');
    }

    onSubmit = (formData: any) => {
        const { action } = this.props;
        const { isLoading } = this.state;

        if (!isLoading) {
            this.setState({ isLoading: true }, async () => {
                try {
                    await action(formData);
                } catch (error) {
                    this.setState({
                        isDirty: true,
                        isLoading: false,
                        message: error.message,
                    });
                }
            });
        }
    };

    renderFormMsg = () => {
        const { isDirty, message } = this.state;
        if (message) {
            return <ErrorMessage as="p" isDirty={isDirty} align="center" i18nKey={message} />;
        }
        return null;
    };

    renderForm = () => {
        const { isLoading } = this.state;
        const { i18n } = this.props;
        return (
            <Form onSubmit={this.onSubmit}>
                <Grid.Container rowGap="24px" style={{ maxWidth: 400 }}>
                    <Title>Get started with email</Title>
                    {this.renderFormMsg()}
                    <Grid.Container cols="repeat(auto-fit, minmax(140px, 1fr))" colGap="8px">
                        <Grid.Cell>
                            <Field label={i18n.t('firstname')} name="firstname">
                                <TextInput />
                            </Field>
                        </Grid.Cell>
                        <Grid.Cell>
                            <Field label={i18n.t('lastname')} name="lastname">
                                <TextInput />
                            </Field>
                        </Grid.Cell>
                    </Grid.Container>
                    <Field label={i18n.t('username')} name="username">
                        <TextInput />
                    </Field>
                    <CreatePassword />
                    <Button
                        type="submit"
                        action="primary"
                        loading={isLoading}
                        width="100%"
                        tight
                        name="customer-signup-complete"
                    >
                        {i18n.t('primaryAction', { context: 'getStarted' })}
                    </Button>
                </Grid.Container>
            </Form>
        );
    };

    renderCard = () => <BookingSoftwareMarketingCard />;

    render() {
        return (
            <Layout secondaryAction={<SecondaryAction {...this.props} />}>
                <Article>
                    <Body>{this.renderForm()}</Body>
                    <Aside>{this.renderCard()}</Aside>
                </Article>
            </Layout>
        );
    }
}

export default withTranslation()(SignUpWithEmail);
